import * as React from "react";

export function LoadingState() {
  return (
    <div className="ns-center">
      <div className="ns-spinner" />
      <p className="ns-text">Loading notifications...</p>
    </div>
  );
}

export function EmptyState({ filter }) {
  const msgs = {
    all:    { icon: "🔔", title: "No notifications yet", sub: "When something happens, you'll see it here." },
    unread: { icon: "✅", title: "All caught up!", sub: "No unread notifications at the moment." },
    read:   { icon: "📭", title: "Nothing read yet", sub: "Notifications you've read will appear here." },
  };
  const { icon, title, sub } = msgs[filter] || msgs.all;

  return (
    <div className="ns-center ns-empty">
      <div className="ns-icon">{icon}</div>
      <h2 className="ns-title">{title}</h2>
      <p className="ns-sub">{sub}</p>
    </div>
  );
}

export function DeleteConfirmModal({ id, onConfirm, onCancel, loading }) {
  const isAll = id === "all";
  return (
    <div className="ns-overlay" onClick={onCancel}>
      <div className="ns-modal" onClick={(e) => e.stopPropagation()}>
        <div className="ns-modal-icon">🗑️</div>
        <h3 className="ns-modal-title">
          {isAll ? "Delete all notifications?" : "Delete this notification?"}
        </h3>
        <p className="ns-modal-sub">
          {isAll
            ? "This will permanently remove all your notifications."
            : "This action cannot be undone."}
        </p>
        <div className="ns-modal-btns">
          <button className="ns-modal-cancel" onClick={onCancel} disabled={loading}>
            Cancel
          </button>
          <button className="ns-modal-confirm" onClick={onConfirm} disabled={loading}>
            {loading ? <span className="nc-spin" /> : "Delete"}
          </button>
        </div>
      </div>
    </div>
  );
}